import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, ZapIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Features',
    href: '#features'
  }, {
    name: 'How It Works',
    href: '#how-it-works'
  }, {
    name: 'Frameworks',
    href: '#frameworks'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-xl border-b border-slate-200/50 shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-252">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between relative" data-id="element-253">
        {/* Logo */}
        <div className="flex items-center space-x-2 z-10" data-id="element-254">
          <div className="w-6 h-6 overflow-hidden flex items-center justify-center" data-id="element-255">
            <img src="https://cdn.magicpatterns.com/uploads/hRxQvVCJnxZUvLiFBQfhZy/Kinase_logo_—_transparent,_cropped.png" alt="Kinase Icon" className="h-full w-auto object-cover object-left" style={{
            filter: 'brightness(0) saturate(100%) invert(55%) sepia(60%) saturate(500%) hue-rotate(130deg) brightness(95%) contrast(90%)'
          }} data-id="element-256" />
          </div>
          <div className="flex items-baseline gap-2" data-id="element-257">
            <span className="text-xl font-bold text-slate-900 tracking-tight leading-none" data-id="element-258">
              Kinase
            </span>
            <span className="text-[10px] text-slate-400 font-normal italic tracking-wide" data-id="element-259">
              (ky · nase)
            </span>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center justify-center space-x-8 absolute left-1/2 -translate-x-1/2" data-id="element-260">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-261">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center space-x-4 z-10" data-id="element-262">
          <a href="https://app.getkinase.com" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-263">
            Sign in
          </a>
          <a href="https://app.getkinase.com" className="bg-teal-500 hover:bg-teal-400 text-white px-5 py-2 rounded-lg text-sm font-medium transition-colors flex items-center space-x-1.5" data-id="element-264">
            <ZapIcon className="w-3.5 h-3.5" data-id="element-265" />
            <span data-id="element-266">Request free early access</span>
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center" data-id="element-267">
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-900 p-2 transition-colors" aria-label="Toggle menu" data-id="element-268">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-269" /> : <MenuIcon className="w-6 h-6" data-id="element-270" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white border-b border-slate-200 shadow-lg py-4 px-6 flex flex-col space-y-4" data-id="element-271">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-slate-600 hover:text-slate-900 py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-272">
              {link.name}
            </a>)}
          <div className="pt-4 border-t border-slate-100 flex flex-col space-y-4" data-id="element-273">
            <a href="https://app.getkinase.com" className="text-base font-medium text-slate-600 hover:text-slate-900 text-center py-2" data-id="element-274">
              Sign in
            </a>
            <a href="https://app.getkinase.com" className="bg-teal-500 hover:bg-teal-400 text-white px-5 py-3 rounded-lg text-sm font-medium w-full transition-colors flex items-center justify-center space-x-1.5" data-id="element-275">
              <ZapIcon className="w-3.5 h-3.5" data-id="element-276" />
              <span data-id="element-277">Request free early access</span>
            </a>
          </div>
        </div>}
    </header>;
}